var render = function render(_c,_vm){return _c('a-default-stamp',{attrs:{"color":"primary","rotation":3,"border":"0.1rem solid","radius":"0"}},[_vm._v("Ajouté")])
}
var staticRenderFns = []

export { render, staticRenderFns }